import 'jquery';
import 'fitvids.1.1.0';
import 'flexslider';
import 'vendor/jquery.ghostHunter';
import 'index';
import 'key-features';
import 'helper';

// css 在 js 中公用一个入口
import '../css/application.scss';

